import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
type HorizontalTabItemProps = {
  tab: string;
  isActive: boolean;
  className?: string;
  activeClassName?: string;
  link?: string;
  onClick?: (...args: any[]) => any;
};
const HorizontalTabItem: React.SFC<HorizontalTabItemProps> = props => {
  //An optional event handler when `onClick` prop is supplied instead of `link`
  function handleClick() {
    const { tab } = props;
    props.onClick(tab);
  }
  const {
    children,
    className = 'bo-r--1 border-color--white-dark inline-block',
    isActive,
    activeClassName = 'bo-b--5 border-color--muted-dark',
    link,
  } = props;
  return (
    <div className={`${className}`} onClick={!link ? handleClick : () => {}}>
      {link ? (
        <Link
          to={link}
          className={`${
            isActive ? `${activeClassName} bg-color--hover-muted-light` : 'bg-color--hover-primary'
          } bg-color--transition-300ms-ease-out text--bold hover--no-underline inline-block height--40 ph pt-`}
        >
          {children}
        </Link>
      ) : (
        children
      )}
    </div>
  );
};
function mapStateToProps(state) {
  return {
    routing: state.routing,
  };
}
function mapDispatchToProps() {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HorizontalTabItem);
